export default __webpack_public_path__ + "static/media/residency cultural visa.4b1f8d9b.jpg";